import { history } from 'umi';
import { getDownLoadCSVResponseHeaderFileName } from '@gp/utils/common';

import type { AxiosResponse } from 'axios';

export const getIsPDFFile = (path?: string): boolean => {
  if (!path) return true;
  return path.toLowerCase().endsWith('.pdf');
};

export const generatePDFPreviewUrl = (url: string): string => {
  if (!url) return '';
  return `${url}#scrollbar=0&toolbar=0&statusbar=0&view=FitH,top`;
};

export const getFileData = (
  res: AxiosResponse<Blob>,
): {
  url: string;
  suffix: string;
} => {
  const fileName = getDownLoadCSVResponseHeaderFileName(res?.headers);
  const fileSuffix = fileName?.substring(fileName?.lastIndexOf('.') + 1) || 'pdf';
  const stream = res?.data;
  const blob = new Blob([stream], {
    type: `application/${fileSuffix};chartset=UTF-8`,
  });
  const blobUrl = URL.createObjectURL(blob);
  return { url: blobUrl, suffix: fileSuffix };
};

/**
 * 点击左上角返回的跳转处理方法
 * @param referer 访问来源链接可能时完整的url链接，也可能是路由path
 */
export const navigateBack = (referer?: string) => {
  if (!referer) return;

  const isRoutePath = referer?.startsWith('/') || false;

  if (isRoutePath) {
    history.replace(referer);
    return;
  }

  window.location.href = referer;
};
